<template>
  <DisplayLoading
    :isLoading="isLoading"
    :isError="isError"
    :loadingMessage="loadingMessage"
    :errorMessage="errorMessage"
  >
    <div v-if="pageData">
      <PageHeader text="Страница редактирования пользователя" />
      <UserForm :initialValues="user" />
    </div>
    <div v-else>Нет данных для этого пользователя</div>
  </DisplayLoading>
</template>

<script>
import DisplayLoading from '@/components/common/DisplayLoading.vue'
import UserForm from '@/components/forms/UserForm.vue'
import PageHeader from '@/components/common/PageHeader.vue'

import { loadPageData } from '@/mixins/loadPageData'
import { routeParams } from '@/mixins/routeParams'

import { API_USERS } from '@/store/const/apiPaths'

export default {
  data() {
    return {
      loadingMessage: 'Загружаю данные пользователя',
    }
  },
  components: {
    UserForm,
    PageHeader,
    DisplayLoading,
  },
  mixins: [routeParams, loadPageData],
  computed: {
    loadUrl() {
      return `${API_USERS}/${this.userId}`
    },
    errorMessage() {
      return `Не удалось загрузить данные для пользователя: ${this.userId}`
    },
    user() {
      return this.pageData
    },
  },
}
</script>
